import { IDefineCommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { INotificationDelegate } from '../../../../global/helpers/notification_delegate';
import { APGenericSlot } from '../../../builders/ap_generic_slot_builder';
import { IAPAPMarkAsMetStatusDatasource } from '../../mark_as_met/datasources/mark_as_met_status_datasource';
import { IMarkAsMetUnmetUrl } from '../../mark_as_met/stratgies/mark_as_met_unmet_url_strategy';
import { IUpdateProgramSlotCommand } from './../../../../plan/commands/update_program_slot_command';

angular
  .module('capability-ng-academic-planner')
  .factory(
    'deleteMarkAsMetEntryCommand',
    (
      defineCommandORM: IDefineCommand,
      $http: ng.IHttpService,
      markAsMetUnmetUrl: IMarkAsMetUnmetUrl,
      ngAPNotificationDelegate: INotificationDelegate,
      updateProgramSlotCommand: IUpdateProgramSlotCommand,
      log: any,
      ngAPMarkAsMetStatusDatasource: IAPAPMarkAsMetStatusDatasource
    ) =>
      defineCommandORM('deleteMarkAsMetEntryCommand', (deferred, slot: APGenericSlot) => {
        const statusEntry = _4.first(
          ngAPMarkAsMetStatusDatasource.query((_statusEntry) => _statusEntry.program_slot === slot.programSlot.id)
        );
        if (!statusEntry) {
          ngAPNotificationDelegate.error(`Unable to mark as unmet`);
          log.error(`status entry didn't find in datasource`);
          deferred.reject();
          return;
        }
        const url = `${markAsMetUnmetUrl()}_programslot_status/${statusEntry.id}`;
        $http
          .delete(url)
          .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
            ngAPMarkAsMetStatusDatasource.del(statusEntry.id);
            return updateProgramSlotCommand(slot.programSlot.id, {
              status: ''
            });
          })
          .then(() => deferred.resolve())
          .catch((e) => {
            ngAPNotificationDelegate.error(`Unable to mark as unmet: ${e.data.detail}`);
            log.error(e);
            deferred.reject(e);
          });
      })
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/mark_as_unmet/command/delete_mark_as_met_entry_command.ts